/* TWENTYFOUR cart tools. Native theme continues to own product adds and quantities. */
(() => {
  if (customElements.get('tf-cart-tools')) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  class TFCartTools extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('submit', e => this.submit(e), options);
      this.addEventListener('change', e => {
        if (e.target.name === 'country') this.provinces();
        else if (e.target.closest('[data-action="shipping"]')) this.feedback('shipping', '');
      }, options);
      this.addEventListener('input', e => {
        if (e.target.closest('[data-action="shipping"]')) this.feedback('shipping', '');
      }, options);
      this.addEventListener('click', e => {
        if (e.target.closest('[data-panel-close]')) this.close();
        const option = e.target.closest('[data-tf-variant]');
        if (option && !option.disabled) this.addVariant(option.dataset.tfVariant);
        const remove = e.target.closest('[data-remove-code]');
        if (remove) this.discount(null, remove.dataset.removeCode);
        if (e.target instanceof HTMLDialogElement) {
          const rect = e.target.getBoundingClientRect();
          if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.close();
        }
      }, options);
      this.addEventListener('keyup', e => { if (e.key === 'Escape') e.stopPropagation(); }, options);
      this.querySelectorAll('dialog').forEach(panel => panel.addEventListener('cancel', e => { e.preventDefault(); this.closest('cart-drawer').dataset.tfPanelEscape = 'true'; this.close(); }, options));
      const country = this.querySelector('[name="country"]');
      if (Array.from(country.options).some(o => o.value === this.dataset.defaultCountry)) country.value = this.dataset.defaultCountry;
      this.provinces();
    }
    disconnectedCallback() { this.controller.abort(); }
    provinces() {
      const country = this.querySelector('[name="country"]');
      const province = this.querySelector('[name="province"]');
      let list = [];
      try { list = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) {}
      province.replaceChildren(...list.map(([value, label]) => new Option(label, value)));
      province.disabled = !list.length;
      province.closest('[data-province-field]').hidden = !list.length;
      this.feedback('shipping', '');
      this.shippingMinimum();
    }
    shippingMinimum() {
      const country = this.querySelector('[name="country"]').value;
      const out = this.querySelector('[data-shipping-minimum]');
      if (!out) return;
      if (!country || country === '---') { out.textContent = ''; return; }
      const isNZ = country === 'New Zealand';
      const base = country === 'Australia' ? 150 : isNZ ? 150 : 200;
      let currency = isNZ ? 'NZD' : 'AUD';
      let amount = base;
      const fx = Number(window.Shopify?.currency?.rate);
      if (!isNZ && this.dataset.currency !== 'AUD' && window.Shopify?.currency?.active === this.dataset.currency && fx > 0) {
        amount *= fx;
        currency = this.dataset.currency;
      }
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(amount);
      const label = currency !== 'AUD' && !isNZ ? `${money} (A${base})` : money;
      out.textContent = this.dataset.shippingMinimum.replace('[amount]', label);
    }
    open(name, trigger) {
      this.trigger = trigger || this.closest('cart-drawer').querySelector(`[data-tf-cart-panel="${name}"]`);
      this.querySelectorAll('dialog[open]').forEach(p => p.close());
      // Suspend the theme's document-level focus trap while the native dialog owns focus.
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
      this.querySelector(`[data-panel="${name}"]`).showModal();
    }
    close() {
      this.querySelectorAll('dialog[open]').forEach(p => p.close());
      const drawer = this.closest('cart-drawer');
      if (drawer?.hasAttribute('open') && typeof trapFocus === 'function') trapFocus(drawer, this.trigger || drawer.querySelector('[data-tf-cart-close]'));
    }
    feedback(name, text, error = false) {
      const out = this.querySelector(`[data-panel="${name}"] .tf-cart-feedback`);
      out.textContent = text;
      out.toggleAttribute('data-error', error);
      return out;
    }
    busy(name, busy) {
      this.querySelector(`[data-panel="${name}"]`).setAttribute('aria-busy', String(busy));
      this.querySelectorAll(`[data-panel="${name}"] button`).forEach(b => { if (!b.hasAttribute('data-panel-close')) b.disabled = busy; });
    }
    async request(path, body) {
      const res = await fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body), signal: this.controller.signal });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
      return data;
    }
    async refresh(data, reopen) {
      let sections = data.sections;
      if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(this.dataset.error);
        sections = await response.json();
      }
      const inner = parse(sections['cart-drawer']).querySelector('#CartDrawer .cart-drawer__inner');
      const bubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (!inner || !bubble) throw new Error(this.dataset.error);
      const drawer = this.closest('cart-drawer');
      this.querySelectorAll('dialog[open]').forEach(p => p.close());
      drawer.querySelector('.cart-drawer__inner').innerHTML = inner.innerHTML;
      document.getElementById('cart-icon-bubble').innerHTML = bubble.innerHTML;
      drawer.classList.toggle('is-empty', data.item_count === 0);
      const next = drawer.querySelector('tf-cart-tools');
      if (next && reopen) next.open(reopen);
      else if (typeof trapFocus === 'function') trapFocus(drawer, drawer.querySelector('[data-tf-cart-close]'));
      return next;
    }
    async submit(event) {
      const form = event.target.closest('[data-action]');
      if (!form) return;
      event.preventDefault();
      if (form.querySelector('[type="submit"]').disabled) return;
      const action = form.dataset.action;
      if (action === 'discount') return this.discount(form.elements.tf_discount.value.trim());
      this.busy(action, true);
      this.feedback(action, '');
      try {
        if (action === 'note') {
          await this.request('cart/update.js', { note: form.elements.note.value });
          this.feedback(action, this.dataset.saved);
        } else if (action === 'shipping') {
          const params = new URLSearchParams({ 'shipping_address[country]': form.elements.country.value, 'shipping_address[zip]': form.elements.zip.value.trim() });
          if (!form.elements.province.disabled) params.set('shipping_address[province]', form.elements.province.value);
          const prepared = await fetch(root() + 'cart/prepare_shipping_rates.json?' + params, { method: 'POST', signal: this.controller.signal });
          if (!prepared.ok) {
            const err = await prepared.json();
            throw new Error(Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join('. '));
          }
          let data = null;
          for (let attempt = 0; attempt < 12; attempt++) {
            const res = await fetch(root() + 'cart/async_shipping_rates.json?' + params, { signal: this.controller.signal });
            if (!res.ok) throw new Error(this.dataset.error);
            data = await res.json();
            if (data !== null) break;
            await new Promise(resolve => setTimeout(resolve, 750));
            if (!this.isConnected) return;
          }
          if (!data) throw new Error(this.dataset.error);
          const rates = data.shipping_rates || [];
          const out = this.feedback(action, rates.length ? '' : this.dataset.noRates);
          for (const rate of rates) {
            const line = document.createElement('p');
            const currency = rate.currency || this.dataset.currency || 'AUD';
            const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(rate.price));
            line.textContent = `${rate.name}: ${amount} ${currency}`;
            out.appendChild(line);
          }
          if (rates.length) { const note = document.createElement('p'); note.textContent = this.dataset.rateNote; out.appendChild(note); }
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.feedback(action, error.message || this.dataset.error, true);
      } finally { if (this.isConnected) this.busy(action, false); }
    }
    showVariants(button) {
      const list = this.querySelector('.tf-cart-options-grid');
      list.replaceChildren();
      this.querySelector('.tf-cart-variant-product').textContent = button.closest('.tf-cart-suggestion').querySelector('.tf-cart-suggestion-title').textContent;
      for (const variant of JSON.parse(button.dataset.variants)) {
        const option = document.createElement('button');
        option.type = 'button'; option.className = 'tf-cart-variant-option';
        option.dataset.tfVariant = variant.id; option.textContent = variant.title;
        option.disabled = !variant.available; list.appendChild(option);
      }
      this.feedback('variant', '');
      this.open('variant', button);
    }
    async addVariant(id) {
      const panel = this.querySelector('[data-panel="variant"]');
      if (panel.getAttribute('aria-busy') === 'true') return;
      // Preserve unavailable states while blocking a second submission.
      panel.setAttribute('aria-busy', 'true');
      panel.querySelectorAll('[data-tf-variant]').forEach(b => { b.dataset.wasDisabled = String(b.disabled); b.disabled = true; });
      try {
        const data = await this.request('cart/add.js', { items: [{ id: Number(id), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname });
        await this.refresh(data);
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) this.feedback('variant', error.message || this.dataset.error, true);
      } finally {
        if (this.isConnected) {
          panel.setAttribute('aria-busy', 'false');
          panel.querySelectorAll('[data-tf-variant]').forEach(b => { b.disabled = b.dataset.wasDisabled === 'true'; });
        }
      }
    }
    async discount(code, remove) {
      const panel = this.querySelector('[data-panel="discount"]');
      if (panel.getAttribute('aria-busy') === 'true') return;
      this.busy('discount', true);
      this.feedback('discount', '');
      try {
        // Read actual applied codes first, including shipping codes not allocated in Liquid.
        const res = await fetch(root() + 'cart.js', { signal: this.controller.signal });
        if (!res.ok) throw new Error(this.dataset.error);
        const cart = await res.json();
        const existing = (cart.discount_codes || []).filter(c => c.applicable).map(c => c.code);
        this.querySelectorAll('[data-remove-code]').forEach(b => { if (!existing.some(c => c.toLowerCase() === b.dataset.removeCode.toLowerCase())) existing.push(b.dataset.removeCode); });
        let codes = existing.filter(c => !remove || c.toLowerCase() !== remove.toLowerCase());
        if (code && !codes.some(c => c.toLowerCase() === code.toLowerCase())) codes.push(code);
        const data = await this.request('cart/update.js', { discount: codes.join(','), sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname });
        const applied = (data.discount_codes || []).some(c => c.code.toLowerCase() === code?.toLowerCase() && c.applicable);
        const message = remove ? this.dataset.removed : applied ? this.dataset.applied : this.dataset.invalidCode;
        const next = await this.refresh(data, 'discount');
        if (next) {
          next.feedback('discount', message, !!code && !applied);
          const list = next.querySelector('.tf-cart-code-list');
          for (const discount of (data.discount_codes || []).filter(c => c.applicable)) {
            if (Array.from(list.children).some(b => b.dataset.removeCode?.toLowerCase() === discount.code.toLowerCase())) continue;
            const btn = document.createElement('button');
            btn.type = 'button'; btn.className = 'tf-cart-code'; btn.dataset.removeCode = discount.code;
            btn.textContent = discount.code + ' ×'; btn.setAttribute('aria-label', 'Remove ' + discount.code);
            list.appendChild(btn);
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) this.feedback('discount', error.message || this.dataset.error, true);
      } finally { if (this.isConnected) this.busy('discount', false); }
    }
  }
  customElements.define('tf-cart-tools', TFCartTools);
  document.addEventListener('click', event => {
    const button = event.target.closest('#CartDrawer.tf-rounded-cart .tf-cart-suggestion-add[data-variants]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!button.disabled) button.closest('cart-drawer').querySelector('tf-cart-tools')?.showVariants(button);
  }, true);
  document.addEventListener('keyup', event => {
    const drawer = document.querySelector('#CartDrawer[data-tf-panel-escape]');
    if (event.key === 'Escape' && drawer) { delete drawer.dataset.tfPanelEscape; event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', event => {
    const drawer = event.target.closest('#CartDrawer.tf-rounded-cart');
    if (!drawer) return;
    if (event.target.closest('[data-tf-cart-close]')) drawer.close();
    const panel = event.target.closest('[data-tf-cart-panel]');
    if (panel) drawer.querySelector('tf-cart-tools')?.open(panel.dataset.tfCartPanel, panel);
    const arrow = event.target.closest('[data-tf-cart-slide]');
    if (arrow) {
      const list = drawer.querySelector('.cart-notification__recommend-list');
      if (list) list.scrollBy({ left: Number(arrow.dataset.tfCartSlide) * (list.firstElementChild?.getBoundingClientRect().width + 8 || list.clientWidth), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
})();
